import { useTranslation } from 'react-i18next';
import { Payment, PaymentProps } from '../Payment/Payment';
import styles from './PaymentList.module.scss';

export interface PaymentListProps {
  payments: PaymentProps[];
  onPaymentClick?: (payment: PaymentProps) => void;
  renderPayment?: (payment: PaymentProps) => React.ReactNode;
  className?: string;
  'data-testid': string;
}

export const PaymentList = ({
  payments,
  onPaymentClick,
  renderPayment,
  className,
  'data-testid': dataTestId,
}: PaymentListProps) => {
  const { t } = useTranslation();
  const isEmpty = payments.length === 0;

  return (
    <div
      className={`${styles['payment-list']} ${className || ''}`}
      data-testid={dataTestId}
      // `role="list"` se aplikuje jen když seznam obsahuje položky — prázdný
      // list s jediným `role="status"` potomkem porušuje aria-required-children
      // (list vyžaduje potomky `listitem`). Prázdný stav je tak čistě status region.
      role={isEmpty ? undefined : 'list'}
      aria-label={isEmpty ? undefined : t('payments.listLabel', 'Seznam plateb')}
    >
      {isEmpty ? (
        <div
          className={styles['payment-list-empty']}
          role="status"
          aria-live="polite"
        >
          {t('payments.noPayments', 'Žádné platby')}
        </div>
      ) : (
        payments.map((payment, index) => (
          <div key={index} role="listitem">
            {renderPayment ? (
              renderPayment(payment)
            ) : (
              <Payment
                {...payment}
                onClick={
                  onPaymentClick
                    ? () => onPaymentClick(payment)
                    : payment.onClick
                }
                data-testid={payment['data-testid']}
              />
            )}
          </div>
        ))
      )}
    </div>
  );
};
